export default __webpack_public_path__ + "static/media/gallery-image-3.d46683fb.png";